<template>
  <el-menu-item :index="routerInfo.path" @click="close">
    {{routerInfo.meta.title}}
  </el-menu-item>
</template>

<script>
export default {
  name: "menuItem",
  props: {
    routerInfo: {
      type: Object,
      default: () => null,
    },
  },
  inject: ["closeDialog"],
  methods:{
    close(){
      this.closeDialog()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/components/menuItem.vue